import { useNavigate, useParams } from "react-router-dom";
import { VentureList, useVentures, useVentureFilters } from "@project-mgmt/feature-ventures";
import { Container, Page, Button } from "@project-mgmt/ui";
import { useWorkspaceDetails } from "@project-mgmt/feature-workspaces";
import { routes } from "../utils/routes";
import type { WorkspaceRouteParams } from "../types/routes";

export function VenturesPage() {
  const navigate = useNavigate();
  const { workspaceId } = useParams() as WorkspaceRouteParams;
  const { data: workspaceData } = useWorkspaceDetails(workspaceId ?? "");
  const currentWorkspace = workspaceData?.workspace;

  // Venture filters
  const { filters, setStatusFilter, setTypeFilter } = useVentureFilters();

  // Fetch ventures for this workspace
  const { data, isLoading, error } = useVentures(workspaceId ?? "", filters);

  console.log("VenturesPage render:", data?.ventures);
  // Handle venture selection - navigate to detail page
  const handleVentureSelect = (ventureId: string) => {
    if (workspaceId) {
      navigate(routes.ventureDetail(workspaceId, ventureId));
    }
  };

  return (
    <Container size="xl">
      <Page className="brand-page">
        {/* Header with Actions */}
        <div className="brand-page-hero mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0 flex-1">
            <p className="brand-page-kicker">Venture Pipeline</p>
            <h1 className="brand-page-title">
              Venture <span className="brand-page-title-accent">Proposals</span>
            </h1>
            <p className="brand-page-subtitle truncate">
              Manage venture proposals in {currentWorkspace?.name}
            </p>
          </div>

          <Button onClick={() => navigate(routes.createVenture(workspaceId))} className="touch-target w-full sm:w-auto">
            <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Create Venture
          </Button>
        </div>

        {/* Ventures List */}
        <div className="brand-section-card p-4 sm:p-6">
          <VentureList
            ventures={data?.ventures ?? []}
            isLoading={isLoading}
            error={data?.ventures && data.ventures.length === 0 ? null : error?.message || null}
            onVentureClick={handleVentureSelect}
            selectedStatus={filters.status}
            selectedCategory={filters.type}
            onStatusFilterChange={setStatusFilter}
            onCategoryFilterChange={setTypeFilter}
            emptyMessage="No ventures yet. Create your first venture to get started."
          />
        </div>
      </Page>
    </Container>
  );
}
